module.exports = __webpack_public_path__ + "img/document-mockup.02d2a1c5.png";